import { StyledSelectable } from './style';
import { Icon } from '../icon';

const Selectable = ({ className, children }) => {
  let klass = `${className} selectable`;

  return(
    <StyledSelectable className={klass}>
      {children}
      <div className="check"><Icon icon="check" /></div>
    </StyledSelectable>
  )
}

export default Selectable;
